// 261005 E2-P2a — mục gập "Phiên bản (n)". Bản đầu danh sách = hiện tại (BE trả mới nhất trước). Khôi phục: `expectedModifiedAt` do vỏ truyền.
import React from 'react';
import { Button, Collapse, Empty, Popconfirm, Spin, Tag, Typography } from 'antd';
import type { AssistantVersion } from '../../../../types/adaptationAssistant';
import { versionOriginLabel, versionTitle } from '../../episodeFixUtils';
import { restoreConfirmText } from './assistantView';
import { formatShortDateTime } from '../../adaptationUtils';

const { Text } = Typography;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  versions: AssistantVersion[] | null;
  /** null = khôi phục được; chuỗi = lý do tắt (tập không nháp, đang bận…). */
  restoreBlocker: string | null;
  acting: string | null;
  /** Mặc định ⑤. ② / ④ : nhãn origin + câu xác nhận riêng. */
  stageKey?: 'script' | 'skeleton' | 'split' | 'source' | 'localize';
  onRestore: (v: AssistantVersion) => void;
}


const AssistantVersions: React.FC<Props> = ({ open, onOpenChange, versions, restoreBlocker, acting, stageKey = 'script', onRestore }) => (
  <Collapse
    size="small" ghost activeKey={open ? ['v'] : []} onChange={(k) => onOpenChange((Array.isArray(k) ? k : [k]).includes('v'))}
    items={[{
      key: 'v',
      label: `Phiên bản${versions ? ` (${versions.length})` : ''}`,
      children: (
        <div>
          {versions === null && <Spin size="small" />}
          {versions && versions.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có phiên bản nào" />}
          {restoreBlocker && versions && versions.length > 0 && <Text type="secondary" style={{ fontSize: 13, display: 'block', marginBottom: 4 }}>{restoreBlocker}</Text>}
          {stageKey === 'source' && versions && versions.length > 0 && <Text type="secondary" style={{ fontSize: 13, display: 'block', marginBottom: 4 }}>Mỗi dòng là một thao tác lên chương. Chỉ hoàn tác được thao tác mới nhất (dòng đầu).</Text>}
          {versions?.map((v, i) => (
            <div key={v.versionId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--wb-line-soft)' }}>
              <div style={{ minWidth: 0 }}>
                <Text strong style={{ wordBreak: 'break-word' }}>{versionTitle(v, stageKey)}</Text> {i === 0 && <Tag color="green">{stageKey === 'source' ? 'mới nhất' : 'hiện tại'}</Tag>}
                <div style={{ fontSize: 13, color: 'var(--wb-text-3)' }}>{formatShortDateTime(v.createdAt)} · {versionOriginLabel(v.origin, stageKey)}</div>
              </div>
              {(stageKey === 'source' ? i === 0 : i > 0) && (
                <Popconfirm
                  title={stageKey === 'source' ? `Hoàn tác thao tác v${v.versionNo}?` : `Khôi phục v${v.versionNo}?`} description={restoreConfirmText(stageKey)}
                  okText={stageKey === 'source' ? 'Hoàn tác' : 'Khôi phục'} cancelText="Thôi" onConfirm={() => onRestore(v)} disabled={!!restoreBlocker}
                >
                  <Button size="small" disabled={!!restoreBlocker} loading={acting === `restore-${v.versionId}`}>{stageKey === 'source' ? 'Hoàn tác thao tác này' : 'Khôi phục'}</Button>
                </Popconfirm>
              )}
            </div>
          ))}
        </div>
      ),
    }]}
  />
);

export default AssistantVersions;
